import { render, staticRenderFns } from "./association-member.vue?vue&type=template&id=586437c9&scoped=true&"
import script from "./association-member.vue?vue&type=script&lang=js&"
export * from "./association-member.vue?vue&type=script&lang=js&"
import style0 from "./association-member.vue?vue&type=style&index=0&id=586437c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586437c9",
  null
  
)

export default component.exports